/**
 * Calculates the iframe url from the href attribute of the link
 *
 * Example:
 *   getIframeUrl("http://localhost:8080/experience/the-owls-are-not-what-they-seem")
 *   => "http://localhost:8080/embed/the-owls-are-not-what-they-seem"
 *
 * @param  {string} href
 * @returns {string}
 */
export default function getIframeUrl(href) {
  return href.replace("/experience/", "/embed/");
}
